import type { UcProblemStatsSection } from '../../../lib/useCaseQueries';
import { UseCaseBand, UseCaseSceneSlug } from '../primitives';

type UcProblemStatsSectionProps = {
  data: UcProblemStatsSection;
  tone: 'light' | 'dark';
};

export function UcProblemStatsSection({ data, tone }: UcProblemStatsSectionProps) {
  return (
    <UseCaseBand tone={tone} id="problem" className="uc-problem-stats">
      <UseCaseSceneSlug sceneNumber={data.sceneNumber} sceneLabel={data.sceneLabel} />
      {data.heading && (
        <h2 className="a-lead reveal">
          <b>{data.heading}</b>
        </h2>
      )}
      {data.stats && data.stats.length > 0 && (
        <div className="uc-stat-list reveal">
          {data.stats.map((stat) => (
            <div key={`${stat.value}-${stat.label}`} className="uc-stat-item">
              <div className="uc-stat-val">{stat.value}</div>
              <div className="uc-stat-label">
                <b>{stat.label}</b>
                {stat.detail}
              </div>
            </div>
          ))}
        </div>
      )}
      {data.quote && <p className="uc-stat-quote reveal">{data.quote}</p>}
    </UseCaseBand>
  );
}
